import { Transform } from "class-transformer";
import { toEuros } from "@/utils/numberUtils";

export class CertificationHasConsumablesAnalysisDto {
  certificationId: string;

  consumableId: string;

  consumableName: number;

  @Transform(({ value }) => toEuros(value))
  totalCost = 0;
}
